import React from 'react';
import { connect } from 'react-redux';

import { openState } from 'constants/scenario';
import * as testTypes from 'constants/scenarioTestTypes';
import { openModalScenarioTest, openModalScorm, openModalScenarioBook } from 'actions/modalActions';
import { getScormLink } from 'constants/urls'

export const ScormModalLink = connect(null, { openModalScorm })(
    ({ token, stageItem, scenarioParams, openModalScorm }) => stageItem.state === openState ? (
        <a onClick={() => openModalScorm({
            token,
            folder: stageItem.id,
            cmd: scenarioParams.cmd,
            objkey: scenarioParams.objkey,
            objtype: scenarioParams.objtype,
            name: stageItem.name
        })}>
            {stageItem.name}
        </a>
    ) : stageItem.name
);

const ScormLink = ({ token, stageItem, scenarioParams }) => stageItem.state === openState ? (
    <a href={getScormLink(token, stageItem.id, scenarioParams.cmd)} target="_blank" rel="noopener noreferrer">
        {stageItem.name}
    </a>
) : stageItem.name;

const ModalLink = ({ token, openModalScenarioTest, stageItem, scenarioParams }) => (
    <a
        onClick={() => openModalScenarioTest({
            id: stageItem.id,
            type: testTypes.ONLINE_TEST,
            cmd: scenarioParams.cmd,
            name: stageItem.name,
            token,
        })}
        className="test-modal-link"
    >
        {stageItem.name}
    </a>
);

const TestName = ({ stageItem }) => <span>{stageItem.name}</span>;

const TestLink = connect(null, { openModalScenarioTest })(ModalLink);

const BookModal = connect(null, { openModalScenarioBook })(
    ({ stageItem, scenarioParams, token, openModalScenarioBook }) => (
        <a onClick={() => openModalScenarioBook({
            stageItem,
            token,
            cmd: scenarioParams.cmd
        })}>
            {stageItem.name}
        </a>
    )
);

const testLinkConfig = {
    [testTypes.ONLINE_TEST]: TestLink,
    [testTypes.DISTANCE_TRAINING]: TestLink,
    [testTypes.LIBRARY_OBJ]: TestName,
    [testTypes.SCORM_TEST]: ScormLink,
    [testTypes.LIBRARY_OBJ_BOOK]: BookModal,
    [testTypes.LIBRARY_OBJ_DOC]: BookModal,
};

export const TestComponent = ({ token, stageItem, scenarioParams }) => {
    const { type = 'unknown' } = stageItem;
    const Component = testLinkConfig[type] || TestName;

    return (
        <Component
            token={token}
            stageItem={stageItem}
            scenarioParams={scenarioParams}
        />
    );
};
